export function getLicensePeriodProgress(startDate?: string | null, expiryDate?: string) {
  if (!startDate || !expiryDate) return { label: 'Dates not set', percent: 0 };
  const start = Date.parse(`${startDate}T00:00:00Z`);
  const end = Date.parse(`${expiryDate}T23:59:59Z`);
  const remaining = Math.max(0, end - Date.now());
  const total = end - start;
  const days = Math.ceil(remaining / 86_400_000);
  return {
    label: days > 365 ? `${Math.floor(days / 365)} years remaining` : `${days} days remaining`,
    percent: total > 0 ? Math.round((remaining / total) * 100) : 0,
  };
}
